<template>
  <div>
    <v-btn
      color="green"
      class="ma-2 white--text"
      @click="openUploadModal"
    >
      Image
      <v-icon
        right
        dark
      >
        mdi-cloud-upload
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: "CloudinaryUpload",
  components: {},
  props: {
    folder: {
      type: String,
      required: true
    } 
  },
  methods: {
    // open Cloudinary upload widget
    openUploadModal() {
      window.cloudinary.createUploadWidget(
          {
            cloudName: "vtour",
            uploadPreset: "qymt95ck",
            sources: ["local", "url", "google_drive"],
            folder: this.folder,
            multiple: false,
            singleUploadAutoClose: false,
          },
          (error, result) => {
            if (!error && result && result.event === "success") {
              this.getImg({img_id: result.info.public_id, img_url: result.info.secure_url});
            }
          }
        )
        .open();
    },
    ...mapMutations(['getImg'])
  },

  data() {
    return {
      img_id: "",
      img_url: "",
    };
  },
};
</script>
